module.exports = __webpack_public_path__ + "jab/media/search.eab97d05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/search.svg
// module id = 1481
// module chunks = 0